/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Author from 'ui/src/components/Author';
import Image from 'next/image';
import Link from 'next/link';
import useWindowSize from 'ui/src/hooks/useWindowSize';

type PostFooterAuthorProps = {
  imageUrl: string;
  name: string;
  description: string;
  authorSlug: string;
};

function PostFooterAuthor({ imageUrl, name, description, authorSlug }: PostFooterAuthorProps) {
  const { isDesktop } = useWindowSize();
  const imgSize = isDesktop ? 158 : 81;
  return (
    <Author classes="flex gap-6 pt-8 border-t border-site-neutrals-100">
      <Author.Image classes="!m-0">
        <Link href={`/author/${authorSlug}/`}>
          <Image
            alt={name}
            src={imageUrl}
            width={imgSize}
            height={imgSize}
            className="w-[6.4rem] rounded-full"
            unoptimized
          />
        </Link>
      </Author.Image>
      <div className="">
        <Link href={`/author/${authorSlug}/`}>
          <Author.Name classes="text-lg [&>span]:underline">{name}</Author.Name>
        </Link>
        <Author.Description classes="text-site-neutrals-600 site-paragraph-xs leading-[1.125rem]">
          {description}
        </Author.Description>
      </div>
    </Author>
  );
}

export default PostFooterAuthor;
